import { combineReducers } from "redux";
import {topicSearch, responseHasErrored, topicRender, loginReducer, genusReducer} from './reducers';
const rootReducer = combineReducers({
    topicSearch,
    responseHasErrored,
    topicRender,
    loginReducer,
    genusReducer
});
export default rootReducer;
